import { isUpsellSurface, type UpsellSurface } from 'fym-shared/src/music24/watermarkUpsell';

const STORAGE_KEY = 'm24.upsell.checkoutSurface';

/**
 * Keeps the surface that started a checkout across the Stripe trip, in the tab
 * (`sessionStorage`). `PaymentCompleteView` reads it for `purchase_completed`. A browser that
 * blocks the storage loses only this property.
 */
export function rememberUpsellCheckoutSurface(surface: UpsellSurface): void {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, surface);
  } catch (error) {
    console.error(error);
  }
}

/** Reads the surface and removes it: one purchase reports it one time. Null when there is none. */
export function takeUpsellCheckoutSurface(): UpsellSurface | null {
  try {
    const value = window.sessionStorage.getItem(STORAGE_KEY);
    window.sessionStorage.removeItem(STORAGE_KEY);
    return isUpsellSurface(value) ? value : null;
  } catch (error) {
    console.error(error);
    return null;
  }
}
